/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { R as RippleEffect, d as defineCustomElement$1 } from './p-LgLeKTkH.js';

const IonRippleEffect = RippleEffect;
const defineCustomElement = defineCustomElement$1;

export { IonRippleEffect, defineCustomElement };
